import { injectable } from 'inversify';
import { ISessionAdapterService } from './session-adapter.interface';
import { ISessionMessageResponse } from '../../../interfaces';
import { Observable, Subject } from 'rxjs';

// NOTE: Extension of the window interface in order to emulate the data coming
// from the backend.
declare global {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Window {
        sessionAdapterSubject$: Subject<ISessionMessageResponse>;
    }
}

@injectable()
export class SessionAdapterMock implements ISessionAdapterService {
    sessionObservable(): Observable<ISessionMessageResponse> {
        if (!Boolean(window.sessionAdapterSubject$)) {
            window.sessionAdapterSubject$ = new Subject<ISessionMessageResponse>();
        }

        return window.sessionAdapterSubject$.asObservable();
    }
}
